module.exports = __webpack_public_path__ + "img/step-3.a0abc6c3.gif";